import chroma from 'chroma-js';
import { useTheme } from '@/libs/css';

export function useLabelColors() {
  const { isDarkDangerous } = useTheme();

  function getBgColor(color: string) {
    if (isDarkDangerous.value) {
      const hsl = chroma(color).hsl();
      return chroma
        .hsl(hsl[0], hsl[1], 1 - hsl[2])
        .brighten(0.5)
        .hex();
    }

    return color;
  }

  function getBorderColor(color: string, filled = true) {
    const bgColor = getBgColor(color);

    if (!filled) return bgColor;

    if (isDarkDangerous.value) {
      return chroma(bgColor).brighten(0.5).hex();
    }
    return chroma(bgColor).darken(0.5).hex();
  }

  return { getBgColor, getBorderColor };
}
